<template>
  <div id="scrollTop" class="scroll-to-top" :title="$t('to_top')" @click="toTop">
    <i class="el-icon el-icon-arrow-up"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    scrollEvent() {
        window.addEventListener('scroll',function(){
        //当window的scrolltop距离大于1时，go to
            if ($(window).scrollTop() > 100) {
            $("#scrollTop").fadeIn();
            } else {
            $("#scrollTop").fadeOut();
            }
        })
    },
    toTop() {
      $('html ,body').animate({scrollTop: 0}, 300);
    }
  },
  mounted() {
      this.scrollEvent();
  }
};
</script>

<style scoped>
.scroll-to-top {
  width: 50px;
  height: 50px;
  background: linear-gradient(0deg, #FFD200, #F86DA8);
  border-radius: 0;
  position: fixed;
  left: 51%;
  margin-left: 600px;
  bottom: 80px;
  text-align: center;
  line-height: 50px;
  z-index: 9;
  display: none;
  cursor: pointer;
}
.scroll-to-top.show{
    display: block;
}
.scroll-to-top .el-icon-arrow-up {
  font-size: 24px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/template/ScrollToTop.vue